import { minutesToMs } from '@packages/ui'

export const UNI_V3_TRX_DEFAULTS = {
  ALL: {
    EXPIRE_MS: minutesToMs(30),
    PERCENT_DENOMINATOR: 10_000,
    SLIPPAGE_PERCENT: 50, // 50 / 10_000 = 0.005 * 100 = 0.5%
  },
}
